<template><div>

<div>

<p class="text-center text-h3 pa-5"> {{ $t('Crossword') }} </p>

<div class="d-flex justify-center">

<div style="max-width: 500px" class="text-center pa-3" v-if="page_state == 'settings'">

<p> {{ $t('How many words do you want to have in the crossword?') }} </p>

<v-slider
	:tick-labels="[3,4,5,6,7,8,9,10]"
	min="3"
	max="10"
	ticks="always"
	tick-size="4"
	v-model="number_of_words"
/>

<p>  {{ $t('What length of words do you want?') }}  </p>

<v-range-slider
	:tick-labels="[2,3,4,5,'∞']"
	min="2"
	max="6"
	ticks="always"
	tick-size="4"
	v-model="word_length"
/>

<v-switch v-model="highlight_correct" :label="$t('Easy mode (highlight correct input)')" />

<v-btn @click="start_game"> {{ $t('Start the game') }} </v-btn>

</div></div>

<div v-if="page_state == 'game'" class="d-flex flex-wrap justify-center align-center">

	<Crossword style="overflow-x: auto;" @fail="start_game()" @win="handle_win" @change_indexes="set_nums" :highlight_correct="highlight_correct" ref="CW" :words="nao_words" />
	
	<div class="d-none d-md-flex" style="flex-grow: 0.2"></div>

	<div v-if="questions" class="pl-5 pt-10">
		<p :class="{'text-decoration-line-through' : $refs.CW && q.word == $refs.CW.input_words[q.word] }"
		 v-for="(q, index) in questions"> <span class="pointer" @click="$refs.CW.make_active(q.word)"> {{q.num}}. {{q.question}}  </span></p>
		 <v-btn color="error" v-if="!gameover" @click="$refs.CW.input_mode = false; end_game()"> {{ $t('Give up') }} </v-btn>
		<v-btn v-else @click="page_state = 'settings'"> {{ $t('Play one more') }} </v-btn>
	</div>
</div>


</div>

<v-dialog
	v-model="dialog"
	width="500"
>
	<v-card>
		<div class="text-center text-h3 pa-5"> {{ $t('You won!') }}</div>
	</v-card>
</v-dialog>

</div></template>


<script>

import Crossword from '@/components/Crossword.vue'

let words_by_length, game_interval;

function min_two(word_length) {
	return word_length.map(x => x == 1 ? 2 : x);
}

export default {
	components: {Crossword},
	data() {
		return {
			number_of_words: 5,
			word_length: [2,3],
			nums: null,
			nao_words: null,
			highlight_correct: true,
			page_state: 'settings',
			dialog: false,
			gameover: false,
		}
	},
	methods: {
		set_nums(nums) {
			this.nums = nums;
		},
		start_game() {
			game_interval = setInterval(function() {
				localStorage.game_in_progress = new Date().getTime();
			}, 1000);
			this.gameover = false;
			this.nao_words = [];
	
			for (let i=0; i < this.number_of_words; i++) {
				this.nao_words.push( this.$nao.random_word_with_length(this.word_length).join('') );
			}
			this.page_state = 'game';
		},
		end_game() {
			this.gameover = true;
			clearInterval(game_interval);
		},
		handle_win() {
			this.dialog = true;
			this.end_game();
		}
	},
	computed: {
		questions() {
			if (!this.nums) return null;
			
			let res = this.nums;
			
			for (let w of res) {
				w.question = this.$nao.tr_from_Nao(w.word).main_tr;
			}

			return res;
		}
	},
	created() {
		words_by_length = this.$nao.get_words_by_length();
	},
	beforeDestroy() {
		clearInterval(game_interval);
	},
}


</script>

<style scoped>

.pointer {
	cursor: pointer;
}

div {
	xborder: 1px solid black;
}

</style>